/**
 * Legacy gallery filter for older custom variant pickers.
 * The active PDP (`custom-product-main`) owns filtering via its inline script;
 * skip this harness there so the two never fight over visibility.
 */
document.addEventListener('DOMContentLoaded', () => {
  initCustomGalleryFilter();
});

document.addEventListener('shopify:section:load', () => {
  initCustomGalleryFilter();
});

function initCustomGalleryFilter() {
  if (document.querySelector('.custom-product-section')) return;

  const picker = document.querySelector('.custom-variant-picker');
  if (!picker) return;

  const buttons = picker.querySelectorAll('.swatch-btn');

  buttons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const target = e.currentTarget;
      const parentGroup = target.closest('.option-group');

      if (parentGroup) {
        parentGroup.querySelectorAll('.swatch-btn').forEach((b) => b.classList.remove('selected'));
      }

      target.classList.add('selected');

      const labelValueSpan = parentGroup.querySelector('.option-group__selected-value');
      if (labelValueSpan) {
        labelValueSpan.textContent = target.textContent.trim();
      }

      filterGalleryMedia();
    });
  });

  filterGalleryMedia();
}

function filterGalleryMedia() {
  if (document.querySelector('.custom-product-section')) return;

  const selectedColorBtn = document.querySelector('.custom-variant-picker .color-btn.selected');
  const selectedSizeBtn = document.querySelector('.custom-variant-picker .size-btn.selected');

  const selectedColor = selectedColorBtn ? selectedColorBtn.dataset.value.trim().toLowerCase() : '';
  const selectedSize = selectedSizeBtn ? selectedSizeBtn.dataset.value.trim().toLowerCase() : '';

  const mediaElements = document.querySelectorAll('[data-variant-color], [data-variant-size]');

  mediaElements.forEach((el) => {
    const itemColor = (el.dataset.variantColor || '').trim().toLowerCase();
    const itemSize = (el.dataset.variantSize || '').trim().toLowerCase();

    if (!itemColor && !itemSize) return;

    let isMatch = false;

    if (itemColor && itemSize) {
      isMatch = itemColor === selectedColor && itemSize === selectedSize;
    } else if (itemColor) {
      isMatch = itemColor === selectedColor;
    } else if (itemSize) {
      isMatch = itemSize === selectedSize;
    }

    if (isMatch) {
      el.classList.remove('hidden-variant-media-item');
    } else {
      el.classList.add('hidden-variant-media-item');
    }
  });

  window.dispatchEvent(new Event('resize'));
}
